<template>
  <div class="new-year">
    <div class="banner"></div>
    <div class="progress">
      <canvas ref="canvas" width="360px" height="600px" class="canvas-wrapper"></canvas>
      <div class="content-wrapper">
        <div class="funding-progress">
          <img
            :src="require(`@/assets/image/activity/new-year/reward${index+1}-shadowed.png`)"
            class="reward-image"
            :class="`reward-image_${index+1}`"
            v-for="(i,index) in rewardList"
            :key="index"
          >
          <div class="start-funding" @click="$router.push({name: 'Product'})">
            <div class="start-funding-inner">
              {{ $t('startFunding') }}
            </div>
          </div>
          <md-button
            v-for="(i, index) in rewardValueTipList"
            :key="`reward-tip-${index}`"
            type="green-dark"
            class="reward-value-tip"
            :class="`reward-value-tip_${index + 1}`"
            round
          >
            {{ i.text }}
          </md-button>
        </div>
      </div>
    </div>
    <div class="reward-list">
      <div v-for="(item, index) in rewardList" :key="index" class="reward-card">
        <div class="reward-left">
          <img :src="item.image" class="reward-img">
          <div class="require-label">Kurang</div>
          <div class="require-amount">{{ item.stillNeed | formatMoney }}</div>
        </div>
        <div class="reward-right">
          <div class="reward-name">{{item.rewardName}}</div>
          <div class="reward-value">{{ item.worth | formatMoney }}</div>
          <div class="btn-claim">
            <md-button
              v-if="!loggedIn"
              type="green-light"
              round
              @click="$router.push({ name: 'Login' })"
            >
              {{ $t('login') }}
            </md-button>
            <div v-else>
              <md-button
                v-if="item.status === 'NOT_SATISFIED'"
                type="orange"
                round
                @click="investToast(item.amount - item.currentValue)"
              >
                {{ $t('notEnough') }}
              </md-button>
              <md-button
                v-if="item.status === 'CLAIMING'"
                type="green-light"
                round
                @click="getContactInfo(item)"
              >
                {{ $t('claimNow') }}
              </md-button>
              <md-button
                v-if="item.status === 'CLAIMED'"
                type="grey"
                round
                @click="$toast.info($t('claimedMsg'))"
              >
                {{ $t('claimed') }}
              </md-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <rules></rules>
    <contact-info-dialog
      :visible="dialogVisible"
      @updateContactInfo="claimReward"
      @hideDialog="dialogVisible = false"
    ></contact-info-dialog>
  </div>
</template>

<script>
import { Button } from 'mand-mobile'
import Rules from '@/components/activity/new-year/Rules'
import ContactInfoDialog from '@/components/activity/new-year/ContactInfoDialog'

const INVEST_AMOUNT1 = 10000000
const INVEST_AMOUNT2 = 35000000
const INVEST_AMOUNT3 = 150000000
const INVEST_AMOUNT4 = 1000000000

const REWARD_VALUE1 = 100000
const REWARD_VALUE2 = 350000
const REWARD_VALUE3 = 1500000
const REWARD_VALUE4 = 5000000

export default {
  i18n: {
    messages: {
      en: {
        login: 'Masuk',
        startFunding: 'Pendanaan',
        claimNow: 'Ambil',
        notEnough: 'Poin tidak cukup',
        claimed: 'Sudah diambil',
        notEnoughTip: 'Kamu harus melakukan pendanaan minimum {amount} untuk mendapatkan hadiah',
        successMsg: 'Selamat kamu mendapatkan {reward}, hadiah tersebut akan dikirimkan setelah acara selesai',
        claimedMsg: 'Anda telah mengambil hadiah ini',
      },
      id: {
        login: 'Masuk',
        startFunding: 'Pendanaan',
        claimNow: 'Ambil',
        notEnough: 'Poin tidak cukup',
        claimed: 'Sudah diambil',
        notEnoughTip: 'Kamu harus melakukan pendanaan minimum {amount} untuk mendapatkan hadiah',
        successMsg: 'Selamat kamu mendapatkan {reward}, hadiah tersebut akan dikirimkan setelah acara selesai',
        claimedMsg: 'Anda telah mengambil hadiah ini',
      },
    },
  },
  components: {
    [Button.name]: Button,
    Rules,
    ContactInfoDialog,
  },
  data() {
    return {
      rewardList: [
        {
          rewardName: 'Voucher Xodexo',
          image: require('@/assets/image/activity/new-year/reward1.png'),
          amount: INVEST_AMOUNT1,
          stillNeed: INVEST_AMOUNT1,
          currentValue: 0,
          rewardId: '',
          worth: REWARD_VALUE1,
          status: 'NOT_SATISFIED',
        },
        {
          rewardName: 'Voucher MAP',
          image: require('@/assets/image/activity/new-year/reward2.png'),
          amount: INVEST_AMOUNT2,
          stillNeed: INVEST_AMOUNT2,
          currentValue: 0,
          rewardId: '',
          worth: REWARD_VALUE2,
          status: 'NOT_SATISFIED',
        },
        {
          rewardName: 'Koper Kamiliant',
          image: require('@/assets/image/activity/new-year/reward3.png'),
          amount: INVEST_AMOUNT3,
          stillNeed: INVEST_AMOUNT3,
          currentValue: 0,
          rewardId: '',
          worth: REWARD_VALUE3,
          status: 'NOT_SATISFIED',
        },
        {
          rewardName: 'iPhone X',
          image: require('@/assets/image/activity/new-year/reward4.png'),
          amount: INVEST_AMOUNT4,
          stillNeed: INVEST_AMOUNT4,
          currentValue: 0,
          rewardId: '',
          worth: REWARD_VALUE4,
          status: 'NOT_SATISFIED',
        },
      ],
      rewardValueTipList: [
        { text: 'RP 10 JUTA' },
        { text: 'RP 35 JUTA' },
        { text: 'RP 150 JUTA' },
        { text: 'RP 500 JUTA' },
      ],
      dialogVisible: false,
      investedAmount: 0,
      contactInfo: null,
      currentReward: null,
    }
  },
  computed: {
    loggedIn() {
      return this.$store.getters.loggedin
    },
  },
  mounted() {
    this.initProgress()
  },
  methods: {
    async getRewardList() {
      try {
        let response = await this.$http.get('/marketing/reward/list')
        const { data } = response.data || []
        if (data.length) {
          this.investedAmount = data[0].currentValue || 0
        }
        this.rewardList.forEach((i, index) => {
          const item = data[index]
          if (item) {
            i.currentVale = item.currentValue
            i.rewardId = item.rewardId
            i.status = item.status
            i.stillNeed = i.amount - item.currentValue > 0 ? i.amount - item.currentValue : 0
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    async initProgress() {
      let canvas = this.$refs.canvas
      let ctx = canvas.getContext('2d')
      let width = window.innerWidth
      // 进度折线各个点的坐标
      const points = {
        start: { x: 70, y: 120, amount: 0 },
        reward1Top: { x: width === 320 ? 120 : 146, y: 230 },
        reward1Bottom: { x: width === 320 ? 136 : 154, y: 244 },
        reward2Top: { x: width === 320 ? 240 : 286, y: 336 },
        reward2Bottom: { x: width === 320 ? 255 : 298, y: 355 },
        reward3Top: { x: 94, y: 432 },
        reward3Bottom: { x: 80, y: 447 },
        reward4Top: { x: 256, y: 506 },
      }
      canvas.width = width

      const investAmount1 = this.rewardList[0].amount
      const investAmount2 = this.rewardList[1].amount
      const investAmount3 = this.rewardList[2].amount
      const investAmount4 = this.rewardList[3].amount

      // 画进度条白色背景线条
      drawLines({ endName: 'reward4Top', stokeStyle: '#ccc' })

      await this.getRewardList()

      // 计算当前进度所处的坐标
      let currentPoint = calculateCurrentPoint(this.investedAmount)

      // 画表示当前进度的绿色线条
      drawLines({
        endName: currentPoint.endName,
        stokeStyle: '#8ADF1F',
        mediumPoint: currentPoint.isMedium ? currentPoint.point : null,
      }) // 中间状态需要mediumPoint参数

      // 画绿色指示圆点
      drawCircle(currentPoint.point, 8, '#4AAE1E')
      drawCircle(currentPoint.point, 5, '#8ADF1F')

      /**
       *
       * @param amount
       * @returns {point: {x, y}, isMedium: Boolean, endName: String}
       */
      function calculateCurrentPoint(amount) {
        let point
        let rate
        let endName

        switch (true) {
          case amount >= 0 && amount <= investAmount1:
            rate = amount / investAmount1
            point = {
              x: points.start.x + (points.reward1Top.x - points.start.x) * rate,
              y: points.start.y + (points.reward1Top.y - points.start.y) * rate,
            }
            endName = rate === 1 ? 'reward1Top' : ''
            break
          case (amount > investAmount1 && amount <= investAmount2):
            rate = (amount - investAmount1) / (investAmount2 - investAmount1)
            point = {
              x: points.reward1Bottom.x + (points.reward2Top.x - points.reward1Bottom.x) * rate,
              y: points.reward1Bottom.y + (points.reward2Top.y - points.reward1Bottom.y) * rate,
            }
            endName = rate === 1 ? 'reward2Top' : 'reward1Bottom'
            break
          case (amount > investAmount2 && amount <= investAmount3):
            rate = (amount - investAmount2) / (investAmount3 - investAmount2)
            point = {
              x: points.reward2Bottom.x - (points.reward2Bottom.x - points.reward3Top.x) * rate,
              y: points.reward2Bottom.y + (points.reward3Top.y - points.reward2Bottom.y) * rate,
            }
            endName = rate === 1 ? 'reward3Top' : 'reward2Bottom'
            break
          case (amount > investAmount3 && amount <= investAmount4):
            rate = (amount - investAmount3) / (investAmount4 - investAmount3)
            point = {
              x: points.reward3Bottom.x + (points.reward4Top.x - points.reward3Bottom.x) * rate,
              y: points.reward3Bottom.y + (points.reward4Top.y - points.reward3Bottom.y) * rate,
            }
            endName = rate === 1 ? 'reward4Top' : 'reward3Bottom'
            break
          case (amount > investAmount4):
            point = { x: points.reward4Top.x, y: points.reward4Top.y }
            endName = 'reward4Top'
            break
        }
        return { point, isMedium: rate !== 1, endName: endName }
      }

      function drawLines({ endName, stokeStyle, mediumPoint }) {
        ctx.save()
        ctx.beginPath()
        let count = 1
        for (let key in points) {
          if (endName === '') break
          if (count % 2) {
            ctx.moveTo(points[key].x, points[key].y)
          } else {
            ctx.lineTo(points[key].x, points[key].y)
          }
          if (key === endName) break
          count++
        }
        if (mediumPoint) {
          ctx.moveTo(endName ? points[endName].x : points.start.x, endName ? points[endName].y : points.start.y)
          ctx.lineTo(mediumPoint.x, mediumPoint.y)
        }
        ctx.strokeStyle = stokeStyle
        ctx.lineWidth = 2
        ctx.stroke()
        ctx.restore()
      }

      function drawCircle(point, radius, fillStyle) {
        ctx.save()
        ctx.beginPath()
        ctx.moveTo(point.x, point.y)
        ctx.arc(point.x, point.y, radius, 0, Math.PI * 2, true)
        ctx.fillStyle = fillStyle
        ctx.fill()
      }
    },
    async getContactInfo(reward) {
      this.currentReward = reward
      try {
        const response = await this.$http.get('/marketing/reward/record')
        const info = response.data.data
        if (info) {
          this.contactInfo = info
          this.claimReward()
        } else {
          this.dialogVisible = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    async claimReward(info) {
      if (info) {
        this.contactInfo = info
      }
      try {
        const payload = {
          fullName: this.contactInfo.fullName,
          address: this.contactInfo.address,
          mobile: this.contactInfo.mobile,
          rewardId: this.currentReward.rewardId,
        }
        const response = await this.$http.post('/marketing/reward/claim', payload)
        const { code } = response.data
        if (code === 'SUCCESS') {
          this.$toast.info(this.$t('successMsg', { reward: this.currentReward.rewardName }))
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.initProgress()
      }
    },
    investToast(amount) {
      this.$toast.info(this.$t('notEnoughTip', { amount: this.$options.filters.formatMoney(amount) }))
    },
  },
}
</script>

<style scoped lang="stylus">
green-bg = #3FA328
green-light = #16AD6C
green-medium = #077247
green-dark = #016610

orange = #FFAC00
grey = #A0A0A0

.banner
  height 270px
  background-image url("../../assets/image/activity/new-year/banner-top.png")
  background-size cover

.progress
  position relative
  background-image url("../../assets/image/activity/new-year/bg-progress.jpg")
  background-size 100% 100%
  height 600px
  .canvas-wrapper
    position absolute
    top 0
    left 0
    z-index 1
  .content-wrapper
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    overflow-x: hidden
    z-index 2
    .funding-progress
      position relative
      width 100%
    .reward-image
      position absolute
      max-width 165px
      max-height 165px
    .reward-image_1
      left 110px
      top 147px
    .reward-image_2
      right -10px
      top 217px
    .reward-image_3
      left 0
      top 290px
    .reward-image_4
      right 25px
      top 370px
    .reward-value-tip
      position absolute
      &.md-button
        width auto
        height 30px
        padding: 1px 2px
      &.green-dark
        background-color #016610
        color #fff
        box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.37)
        border: 1px solid rgba(255, 255, 255, 1)
        &.round
          border-radius 8px
    .start-funding
      position absolute
      left 20px
      top 42px
      width 80px
      height 80px
      background-image url("../../assets/image/activity/new-year/icon-start.png")
      background-size cover
      .start-funding-inner
        color #fff
        width 70px
        height 52px
        margin-left 5px
        font-size 10px
        font-weight bold
        display flex
        justify-content center
        align-items center
        text-align center
    .reward-value-tip_1
      left 40px
      top 252px
    .reward-value-tip_2
      right 10px
      top 365px
    .reward-value-tip_3
      left 16px
      top 468px
    .reward-value-tip_4
      right 30px
      top 536px

.reward-list
  position relative
  margin-top -24px
  background-color green-bg
  padding 40px 16px 20px
  border-radius 200px 200px 0 0 / 26px 26px 0 0
  z-index 3

.reward-card
  background-color #fff
  box-shadow 0 0 7px 0 rgba(0, 0, 0, 0.28)
  border-radius 6px
  padding 12px 0
  margin-bottom 16px
  display flex
  justify-content flex-start
  .reward-left
    width 45%
    padding 0 18px 0 20px
    border-right 1px solid #D8D8D8
    display flex
    flex-direction column
    justify-content flex-start
    align-items center
    .reward-img
      max-width 108px
      max-height 65px
    .require-label
      color #AFAFAF
      font-size 12px
      font-weight 500
      margin-bottom 3px
    .require-amount
      color #5E5E5E
      font-size 12px
      font-weight bold
      @media (max-width 320px ) {
        font-size 11px
      }
  .reward-right
    padding-left 22px
    font-size 16px
    .reward-name
      color green-medium
      font-weight bold
      line-height 20px
      margin-bottom 2px
    .reward-value
      color #5E5E5E
      font-weight bold
      margin-bottom 14px
    .btn-claim
      .md-button
        width auto
        font-size 14px
        color #fff
        height 28px
        @media (max-width 320px ) {
          font-size 11px
        }
        &.green-light
          background-color green-light
        &.orange
          background-color orange
        &.grey
          background-color grey
        &.round
          border-radius 6px
</style>
